module.exports = {
  product_type: null,
  amount: null,
  price: null,
  status: 1
}